import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ParkInterface } from '@app/app/shared/interfaces/park.interface';
import { ParksService } from '@app/app/shared/services/parks.service';

@Injectable()
export class ParksResolver implements Resolve<ParkInterface[]> {
  constructor(private parksService: ParksService) {
  }

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ParkInterface[]> {
    return this.parksService.fetchList();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/resolvers/parks.resolver.ts